"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UsersTableField;
(function (UsersTableField) {
    UsersTableField[UsersTableField["Email"] = 0] = "Email";
    UsersTableField[UsersTableField["DisplayName"] = 1] = "DisplayName";
    UsersTableField[UsersTableField["UserRole"] = 2] = "UserRole";
    UsersTableField[UsersTableField["DefaultLocation"] = 3] = "DefaultLocation";
})(UsersTableField = exports.UsersTableField || (exports.UsersTableField = {}));
//# sourceMappingURL=UsersTableField.js.map